<template>
   <div>
        <div >
            <v-form
               ref="create_language"
               v-model="valid_create_language"
            >

               <div class="grid gap-4">

                  <registration-title :title="$t('Lingue')">
                  </registration-title>
                  <div class="grid md:grid-cols-2 gap-2">

                     <!-- Italiano -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='it'/>
                           </div>
                           <div>{{$t('Italiano')}}: </div>
                        </div>
                        <div class="flex flex-col grow" >
                           <v-autocomplete
                              v-model="user.italiano"
                              :items="items_languages"
                              item-text="label"
                              item-value="value"
                              hide-details="auto"
                              :placeholder="$t('Non conosco')"
                              outlined
                              dense
                           ></v-autocomplete>
                           <v-text-field
                              class="input_transparent -mb-[2rem]"
                              :rules="disable_rules ? [] : [validation_rules.required_not0]"
                              v-model="user.italiano"
                           ></v-text-field>
                        </div>
                     </div>
                     
                     <!-- inglese -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='gb'/>
                           </div>
                           <div>{{$t('Inglese')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.inglese"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- francese -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='fr'/>
                           </div>
                           <div>{{$t('Francese')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.francese"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- spagnolo -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='es'/>
                           </div>
                           <div>{{$t('Spagnolo')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.spagnolo"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- portoghese -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='pt'/>
                           </div>
                           <div>{{$t('Portoghese')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.portoghese"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- tedesco -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='de'/>
                           </div>
                           <div>{{$t('Tedesco')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.tedesco"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- cinese -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='cn'/>
                           </div>
                           <div>{{$t('Cinese')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.cinese"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- arabo -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='sa'/>
                           </div>
                           <div>{{$t('Arabo')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.arabo"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>
                     
                     <!-- russo -->
                     <div class="flex justify-between">
                        <div class="flex items-center w-[175px] min-w-[fit-content] font-bold text-grey">
                           <div class="-mt-[1rem] mr-1 drop-shadow-xl">
                              <country-flag country='ru'/>
                           </div>
                           <div>{{$t('Russo')}}:</div>
                        </div>
                        <v-autocomplete
                           v-model="user.russo"
                           :items="items_languages"
                           item-text="label"
                           item-value="value"
                           hide-details="auto"
                           :placeholder="$t('Non conosco')"
                           outlined
                           dense
                        ></v-autocomplete>
                     </div>

                     

                     <!-- madrelingua -->
                     <div class="md:col-span-2 flex">
                        <div>
                           <v-text-field
                              class="input_transparent"
                              :rules="disable_rules ? [] : [validation_rules.madrelingua]"
                              v-model="madrelingua_check"
                           ></v-text-field>
                        </div>
                     </div>


                  </div>

                  <registration-title :title="$t('Altre lingue') + ' (' + $t('facoltativo') + ')'">
                  </registration-title>
                  <div class="grid gap-2">

                     <!-- Language -->
                     <div
                        v-for="(lingua,index) in altre_lingue"
                        :key="index"
                        class="flex flex-col md:flex-row justify-between gap-2"
                     >
                        <div class="flex flex-col grow relative" >
                           <v-autocomplete
                              v-model="lingua.name"
                              :items="all_languages"
                              item-text="text"
                              item-value="value"
                              hide-details="auto"
                              outlined
                              dense
                           ></v-autocomplete>
                           <!-- <p class="absolute top-[1.2rem] left-[1.4rem] placeholder_language">{{lingua.name}}</p> -->
                           <v-text-field
                              class="input_transparent -mb-[2rem]"
                              :rules="((!index || disable_rules) && !lingua.value && altre_lingue.length == 1) ? [] : [validation_rules.required_not0]"
                              v-model="lingua.name"
                           ></v-text-field>
                        </div>
                        <div class="flex flex-col grow" >
                           <v-autocomplete
                              v-model="lingua.value"
                              :items="items_languages"
                              item-text="label"
                              item-value="value"
                              hide-details="auto"
                              :placeholder="$t('Non conosco')"
                              outlined
                              dense
                              @blur="hide = index"
                           ></v-autocomplete>
                           <v-text-field
                              class="input_transparent -mb-[2rem]"
                              :rules="((!index || disable_rules) && !lingua.name && altre_lingue.length == 1) ? [] : [validation_rules.required_not0]"
                              v-model="lingua.value"
                           ></v-text-field>
                        </div>
                        <v-btn
                           class="hidden md:block"
                           color="red"
                           :disabled="altre_lingue.length == 1 && altre_lingue[0].name == '' && altre_lingue[0].value == ''"
                           icon
                           @click="deleteAltreLingue(index)"
                        ><v-icon>mdi-delete</v-icon></v-btn>
                        <a class="md:hidden flex items-center justify-center text-red" @click="altre_lingue.splice(index, 1)">{{$t('Elimina')}}</a>
                     </div>
                     <!-- end Lingua -->

                     <div v-if="altre_lingue.length < 10">
                        <v-btn @click="altre_lingue.push({ name: '', value: '' })" color="primary">{{$t('Aggiungi lingua')}}</v-btn>
                     </div>

                  </div>

               </div>

               
               <div class="flex justify-between items-end mt-5 pt-1 border-t border-[#e5e7eb]">
                  <!-- <a color="#808080" @click="logout">Logout</a> -->
                  <v-btn color="grey" dark :loading="btn_loading" @click="$emit('nextStep',1)">{{$t('Indietro')}}</v-btn>
                  <v-btn color="green" dark :loading="btn_loading" @click="nextStep()">{{$t('Avanti')}}</v-btn>
               </div>
            </v-form>
        </div>
   </div>
</template>

<script>
export default {
    data() {
      return {
         btn_loading: false,
         disable_rules: true,
         valid_create_language: true,

         altre_lingue: [
            { name: '', value: '' }
         ],
         first: false,
         
      };
   },
   computed: {
      user() {
         let _user = this.$store.getters['user/user']

         if(_user && !this.first)
            this.setAltreLingue(JSON.parse(JSON.stringify(_user)))

         return _user
      },
      madrelingua_check(){
         if(
               this.user.italiano == 4 
            || this.user.inglese == 4 
            || this.user.francese == 4 
            || this.user.spagnolo == 4 
            || this.user.portoghese == 4 
            || this.user.tedesco == 4 
            || this.user.cinese == 4 
            || this.user.arabo == 4 
            || this.user.russo == 4
            || (this.altre_lingue[0] && this.altre_lingue[0].value == 4)
            || (this.altre_lingue[1] && this.altre_lingue[1].value == 4)
            || (this.altre_lingue[2] && this.altre_lingue[2].value == 4)
            || (this.altre_lingue[3] && this.altre_lingue[3].value == 4)
            || (this.altre_lingue[4] && this.altre_lingue[4].value == 4)
            || (this.altre_lingue[5] && this.altre_lingue[5].value == 4)
            || (this.altre_lingue[6] && this.altre_lingue[6].value == 4)
            || (this.altre_lingue[7] && this.altre_lingue[7].value == 4)
            || (this.altre_lingue[8] && this.altre_lingue[8].value == 4)
            || (this.altre_lingue[9] && this.altre_lingue[9].value == 4)
         )
            return true
         return false
      },
   },
   methods: {
      deleteAltreLingue(index){

         if(this.altre_lingue.length == 1){
            this.altre_lingue = [
               { name: '', value: '' }
            ]
         } else {
            this.altre_lingue.splice(index, 1)
         }

      },
      setAltreLingue(user){

         this.first = true

         let _user = user
         this.altre_lingue = []
         for(let index = 0; index < 10; index++){

            if(_user['altrelingue' + (index ? index : '')] && _user['livellolingua' + (index ? index : '')]){
               this.altre_lingue.push({
                  name: _user['altrelingue' + (index ? index : '')],
                  value: _user['livellolingua' + (index ? index : '')],
               })
            }
            
         }
         if(!this.altre_lingue.length)
            this.altre_lingue.push({ name: '', value: '' })
      },
      async nextStep(){
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.create_language.validate();
         if(valid){
            this.sendEdit()
         }
      },
      async sendEdit(){
            this.btn_loading = true
            let body = {
               italiano: this.user.italiano,
               inglese: this.user.inglese,
               francese: this.user.francese,
               spagnolo: this.user.spagnolo,
               portoghese: this.user.portoghese,
               tedesco: this.user.tedesco,
               cinese: this.user.cinese,
               arabo: this.user.arabo,
               russo: this.user.russo,
               registrazioneCompletata: this.user.registrazioneCompletata < 3 ? 3 : this.user.registrazioneCompletata
            }

            for(let index = 0; index < 10; index++){
               body['altrelingue' + (index ? index : '')] = this.altre_lingue[index] ? this.altre_lingue[index].name : null
               body['livellolingua' + (index ? index : '')] = this.altre_lingue[index] ? this.altre_lingue[index].value : null
            }

            let response = await this.$store.dispatch('user/editUser',body)
            if(response.response.error){
               this.btn_loading = false
               return
            }
            this.$emit("nextStep",3)
            this.btn_loading = false

         
      },
   },
};
</script>

<style lang="scss" scoped>
/*  */
.placeholder_language_focusinput:focus + .placeholder_language{
   background: red;
}
</style>
